import types from '../../mutation-types';

export const actions = {
  setFilters: ({ commit }, filters) => {
    commit(types.SET_ZABBIX_FILTERS, filters);
  },

  getPelangganList: async ({ commit, state, dispatch }, searchQuery = '') => {
    commit(types.SET_ZABBIX_UI_FLAG, { isFetchingPelanggan: true });

    try {
      const filters = state.filters.flatMap(filter => {
        if (filter.value.length > 1) {
          return filter.value.map(v => ({
            tag: filter.tag,
            operator: filter.operator,
            value: v.value,
          }));
        } else {
          return [
            {
              tag: filter.tag,
              operator: filter.operator,
              value: filter.value.map(v => v.value).join(','),
            },
          ];
        }
      });

      const payload = {
        jsonrpc: '2.0',
        method: 'host.get',
        params: {
          selectTags: ['tag', 'value'],
          tags: filters,
          limit: searchQuery || filters.length > 0 ? 0 : 15,
          ...(searchQuery && {
            search: {
              name: [searchQuery],
            },
          }),
        },
        id: 2,
      };

      const response = await axios.post('/zabbix', {
        payload,
      });

      const data = response.data.result;

      commit(types.SET_ZABBIX_PELANGGAN_LIST, data);
      commit(types.SET_ZABBIX_UI_FLAG, { isFetchingPelanggan: false });
    } catch (error) {
      console.error('Error fetching data:', error);
      commit(types.SET_ZABBIX_UI_FLAG, { isFetchingPelanggan: false });
      throw error;
    }
  },
};
